import React, { useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  Button,
  FormControlLabel,
  Radio,
} from "@mui/material";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Tidur Sehat - Hitung Waktu Bangun atau Tidur yang Sehat";
const DESCRIPTION =
  "Gunakan kalkulator tidur sehat untuk menghitung waktu bangun atau tidur berdasarkan siklus tidur Anda atau durasi tidur yang diperlukan. Temukan juga lebih lanjut tentang tidur dan pentingnya bagi kesehatan Anda secara umum.";
const KEYWORDS =
  "kalkulator tidur sehat, siklus tidur, tidur, kesehatan, bangun tidur, tidur sehat, durasi tidur";
const OG_URL = "https://do-calculate.com/calculator/id/sleep/";
const data1 = [
  { ageGroup: "0–3 bulan", recommendedHours: "14–17 jam" },
  {
    ageGroup: "4–12 bulan",
    recommendedHours: "12–16 jam selama 24 jam termasuk waktu tidur siang",
  },
  {
    ageGroup: "1–2 tahun",
    recommendedHours: "11–14 jam selama 24 jam termasuk waktu tidur siang",
  },
  {
    ageGroup: "3–5 tahun",
    recommendedHours: "10–13 jam selama 24 jam termasuk waktu tidur siang",
  },
  { ageGroup: "6–12 tahun", recommendedHours: "9–12 jam selama 24 jam" },
  { ageGroup: "13–18 tahun", recommendedHours: "8–10 jam selama 24 jam" },
  {
    ageGroup: "18–60 tahun",
    recommendedHours: "7 jam atau lebih per malam",
  },
  { ageGroup: "61–64 tahun ", recommendedHours: "7-9 jam" },
  { ageGroup: "65 tahun ke atas", recommendedHours: "7–8 jam" },
];
function SleapCalculator() {
  const [sleepType, setSleepType] = useState("wakeup");
  const [hours, setHours] = useState("");
  const [minutes, setMinutes] = useState("");
  const [pmAm, setPmAm] = useState("AM");
  const [sleepCycle, setSleepCycle] = useState(90);
  const [takesToSleep, setTakesToSleep] = useState(15);
  const [hoursError, setHoursError] = useState("");
  const [minutesError, setMinutesError] = useState("");
  const [sleepCycleError, setSleepCycleError] = useState("");
  const [takesToSleepError, setTakesToSleepError] = useState("");
  const [result1, setResult1] = useState("");
  const [sleepType2, setSleepType2] = useState("wakeup");
  const [hours2, setHours2] = useState("");
  const [minutes2, setMinutes2] = useState("");
  const [pmAm2, setPmAm2] = useState("AM");
  const [sleepHours, setSleepHours] = useState("");
  const [sleepMinutes, setSleepMinutes] = useState("");
  const [hoursError2, setHoursError2] = useState("");
  const [minutesError2, setMinutesError2] = useState("");
  const [sleepHoursError, setSleepHoursError] = useState("");
  const [sleepMinutesError, setSleepMinutesError] = useState("");
  const [result2, setResult2] = useState("");
  const handleHoursChange = (event) => {
    const inputHours = event.target.value;
    if (inputHours !== "") {
      const parsedHours = parseInt(inputHours, 10);
      if (!isNaN(parsedHours) && parsedHours <= 12) {
        setHours(inputHours);
        setHoursError("");
      } else {
        setHours("");
        if (isNaN(parsedHours)) {
          setHoursError("Pastikan memasukkan angka");
        } else if (parsedHours > 12) {
          setHours(inputHours);
          setHoursError("Jumlah jam 12 jam");
        }
      }
    } else {
      setHours("");
      setHoursError("");
    }
  };
  const handleMinutesChange = (event) => {
    const inputMinutes = event.target.value;
    if (inputMinutes !== "") {
      const parsedMinutes = parseInt(inputMinutes, 10);
      if (!isNaN(parsedMinutes) && parsedMinutes <= 60) {
        setMinutes(inputMinutes);
        setMinutesError("");
      } else {
        setMinutes("");
        if (isNaN(parsedMinutes)) {
          setMinutesError("Pastikan memasukkan angka");
        } else if (parsedMinutes > 60) {
          setMinutes(inputMinutes);
          setMinutesError("Menit dalam satu jam adalah 60 menit");
        }
      }
    } else {
      setMinutes("");
      setHoursError("");
    }
  };
  const handleTakesToSleepChange = (event) => {
    const inputTakesToSleep = event.target.value;
    if (inputTakesToSleep !== "") {
      if (!isNaN(inputTakesToSleep)) {
        setTakesToSleep(inputTakesToSleep);
        setTakesToSleepError("");
      } else {
        setTakesToSleep("");
        if (isNaN(inputTakesToSleep)) {
          setTakesToSleepError("Pastikan memasukkan angka");
        }
      }
    } else {
      setTakesToSleep("");
      setTakesToSleepError("");
    }
  };
  const handleSleepCycleChange = (event) => {
    const inputSleepCycle = event.target.value;
    if (inputSleepCycle !== "") {
      if (!isNaN(inputSleepCycle)) {
        setSleepCycle(inputSleepCycle);
        setSleepCycleError("");
      } else {
        setSleepCycle("");
        if (isNaN(inputSleepCycle)) {
          setSleepCycleError("Pastikan memasukkan angka");
        }
      }
    } else {
      setSleepCycle("");
      setSleepCycleError("");
    }
  };
  const handleSubmitCycle = (e) => {
    e.preventDefault();
    if (sleepType === "wakeup") {
      let wakeupHours = parseInt(hours);
      let wakeupMinutes = parseInt(minutes);
      if (pmAm === "PM" && wakeupHours !== 12) {
        wakeupHours += 12;
      }
      if (pmAm === "AM" && wakeupHours === 12) {
        wakeupHours = 0;
      }
      let wakeupTimeMinutes = wakeupHours * 60 + wakeupMinutes;
      const recommendedBedtimes = [];
      const otherBedtimes = [];
      for (let i = 6; i >= 1; i--) {
        let bedtimeMinutes = wakeupTimeMinutes - i * sleepCycle - takesToSleep;
        if (bedtimeMinutes < 0) {
          bedtimeMinutes += 24 * 60;
        }
        let bedtimeHours = Math.floor(bedtimeMinutes / 60);
        let bedtimeMinutesFormatted = bedtimeMinutes % 60;
        let period = "AM";
        if (bedtimeHours >= 12) {
          period = "PM";
          if (bedtimeHours > 12) {
            bedtimeHours -= 12;
          }
        }
        if (bedtimeHours === 0) {
          bedtimeHours = 12;
        }
        const bedtime = {
          hours: bedtimeHours,
          minutes: bedtimeMinutesFormatted,
          period: period,
          cycles: i,
        };
        if (i === 5 || i === 6) {
          recommendedBedtimes.push(bedtime);
        } else {
          otherBedtimes.push(bedtime);
        }
      }
      let resultHTML = `<p>Untuk bangun dengan segar pada pukul <b>${hours}:${minutes.padStart(
        2,
        "0"
      )} ${pmAm === "AM" ? "pagi" : "malam"}</b>, disarankan untuk tidur pada salah satu waktu berikut:</p>`;
      recommendedBedtimes.forEach((bedtime) => {
        resultHTML += `<div><b style="color: green;">${bedtime.hours
          }:${bedtime.minutes.toString().padStart(2, "0")} ${bedtime.period === "AM" ? "pagi" : "malam"} (${bedtime.cycles
          } siklus tidur)</b></div>`;
      });
      resultHTML += `<p>Jika Anda memiliki pengaturan yang berbeda, Anda juga dapat memilih salah satu waktu berikut:</p>`;
      otherBedtimes.forEach((bedtime) => {
        resultHTML += `<div>${bedtime.hours}:${bedtime.minutes
          .toString()
          .padStart(2, "0")} ${bedtime.period === "AM" ? "pagi" : "malam"} (${bedtime.cycles
          } siklus tidur)</div>`;
      });
      setResult1(resultHTML);
    } else if (sleepType === "goToSleep") {
      let bedtimeHours = parseInt(hours);
      let bedtimeMinutes = parseInt(minutes);
      if (pmAm === "PM" && bedtimeHours !== 12) {
        bedtimeHours += 12;
      }
      if (pmAm === "AM" && bedtimeHours === 12) {
        bedtimeHours = 0;
      }
      let bedtimeTimeMinutes = bedtimeHours * 60 + bedtimeMinutes;
      const recommendedWakeupTimes = [];
      const otherWakeupTimes = [];
      for (let i = 1; i <= 6; i++) {
        let wakeupMinutes = bedtimeTimeMinutes + i * sleepCycle + takesToSleep;
        if (wakeupMinutes >= 24 * 60) {
          wakeupMinutes -= 24 * 60;
        }
        let wakeupHours = Math.floor(wakeupMinutes / 60);
        let wakeupMinutesFormatted = wakeupMinutes % 60;
        let period = "AM";
        if (wakeupHours >= 12) {
          period = "PM";
          if (wakeupHours > 12) {
            wakeupHours -= 12;
          }
        }
        if (wakeupHours === 0) {
          wakeupHours = 12;
        }
        const wakeup = {
          hours: wakeupHours,
          minutes: wakeupMinutesFormatted,
          period: period,
          cycles: i,
        };
        if (i === 5 || i === 6) {
          recommendedWakeupTimes.push(wakeup);
        } else {
          otherWakeupTimes.push(wakeup);
        }
      }
      let result = `<p>Jika Anda tidur pada pukul <b>${hours}:${minutes.padStart(
        2,
        "0"
      )} ${pmAm === "AM" ? "pagi" : "malam"}</b>, \n disarankan untuk bangun pada salah satu waktu berikut agar bangun dengan segar:</p>\n\n`;
      recommendedWakeupTimes.forEach((wakeup) => {
        result += `<div><b style="color: green;">${wakeup.hours
          }:${wakeup.minutes.toString().padStart(2, "0")} ${wakeup.period === "AM" ? "pagi" : "malam"} (${wakeup.cycles
          } siklus tidur)</b></div>\n`;
      });
      result += `<p>Jika Anda memiliki pengaturan yang berbeda, Anda juga dapat memilih salah satu waktu berikut:</p>`;
      otherWakeupTimes.forEach((wakeup) => {
        result += `<div>${wakeup.hours}:${wakeup.minutes
          .toString()
          .padStart(2, "0")} ${wakeup.period === "AM" ? "pagi" : "malam"}\t(${wakeup.cycles
          } siklus tidur)</div>`;
      });
      setResult1(result);
    }
  };
  const onReset1 = () => {
    setSleepType("wakeup");
    setHours("");
    setMinutes("");
    setPmAm("AM");
    setSleepCycle("");
    setTakesToSleep("");
    setHoursError("");
    setMinutesError("");
    setSleepCycleError("");
    setTakesToSleepError("");
    setResult1("");
  };
  const handleHours2Change = (event) => {
    const inputHours = event.target.value;
    if (inputHours !== "") {
      const parsedHours = parseInt(inputHours, 10);
      if (!isNaN(parsedHours) && parsedHours <= 12) {
        setHours2(inputHours);
        setHoursError2("");
      } else {
        setHours2("");
        if (isNaN(parsedHours)) {
          setHoursError2("Pastikan memasukkan angka");
        } else if (parsedHours > 12) {
          setHours2(inputHours);
          setHoursError2("Jumlah jam 12 jam");
        }
      }
    } else {
      setHours2("");
      setHoursError2("");
    }
  };
  const handleMinutes2Change = (event) => {
    const inputMinutes = event.target.value;
    if (inputMinutes !== "") {
      const parsedMinutes = parseInt(inputMinutes, 10);
      if (!isNaN(parsedMinutes) && parsedMinutes <= 60) {
        setMinutes2(inputMinutes);
        setMinutesError2("");
      } else {
        setMinutes2("");
        if (isNaN(parsedMinutes)) {
          setMinutesError2("Pastikan memasukkan angka");
        } else if (parsedMinutes > 60) {
          setMinutes2(inputMinutes);
          setMinutesError2("Menit dalam satu jam adalah 60 menit");
        }
      }
    } else {
      setMinutes2("");
      setHoursError2("");
    }
  };
  const handleSleepHoursChange = (event) => {
    const inputSleepCycle = event.target.value;
    if (inputSleepCycle !== "") {
      if (!isNaN(inputSleepCycle)) {
        setSleepHours(inputSleepCycle);
        setSleepHoursError("");
      } else {
        setSleepHours("");
        if (isNaN(inputSleepCycle)) {
          setSleepHoursError("Pastikan memasukkan angka");
        }
      }
    } else {
      setSleepHours("");
      setSleepHoursError("");
    }
  };
  const handleSleepMinutesChange = (event) => {
    const inputTakesToSleep = event.target.value;
    if (inputTakesToSleep !== "") {
      if (!isNaN(inputTakesToSleep)) {
        setSleepMinutes(inputTakesToSleep);
        setSleepMinutesError("");
      } else {
        setSleepMinutes("");
        if (isNaN(inputTakesToSleep)) {
          setSleepMinutesError("Pastikan memasukkan angka");
        }
      }
    } else {
      setSleepMinutes("");
      setSleepMinutesError("");
    }
  };
  const handleSubmitLength = (e) => {
    e.preventDefault();
    if (sleepType2 === "wakeup") {
      const wakeUpHour = parseInt(hours2, 10);
      const wakeUpMinute = parseInt(minutes2, 10);
      const sleepHour = parseInt(sleepHours, 10);
      const sleepMinute = parseInt(sleepMinutes, 10);
      let bedHour = wakeUpHour - sleepHour;
      let bedMinute = wakeUpMinute - sleepMinute;
      let updatedPmAm2 = pmAm2;
      if (bedMinute < 0) {
        bedHour -= 1;
        bedMinute += 60;
      }
      if (bedHour < 0) {
        bedHour += 12;
        updatedPmAm2 = pmAm2 === "AM" ? "PM" : "AM";
      }
      const result = `<div>Anda harus tidur pada: <b  style="color: green;">${bedHour}:${bedMinute
        .toString()
        .padStart(2, "0")} ${updatedPmAm2 === "AM" ? "pagi" : "malam"}</b></div>`;
      setResult2(result);
    } else if (sleepType2 === "goToSleep") {
      const sleepHour = parseInt(hours2, 10);
      const sleepMinute = parseInt(minutes2, 10);
      const wakeUpHour = parseInt(sleepHours, 10);
      const wakeUpMinute = parseInt(sleepMinutes, 10);
      let updatedPmAm2 = pmAm2;
      let wakeHour = wakeUpHour + sleepHour;
      let wakeMinute = wakeUpMinute + sleepMinute;
      if (wakeMinute >= 60) {
        wakeHour += 1;
        wakeMinute -= 60;
      }
      if (wakeHour >= 12) {
        wakeHour -= 12;
        updatedPmAm2 = pmAm2 === "AM" ? "PM" : "AM";
      }
      const result = `Anda harus bangun pada<div>: <b  style="color: green;">${wakeHour}:${wakeMinute
        .toString()
        .padStart(2, "0")} ${updatedPmAm2 === "AM" ? "pagi" : "malam"}</b></div>`;
      setResult2(result);
    }
  };
  const onReset2 = () => {
    setSleepType2("wakeup");
    setHours2("");
    setMinutes2("");
    setPmAm2("AM");
    setSleepHours("");
    setSleepMinutes("");
    setHoursError2("");
    setMinutesError2("");
    setSleepHoursError("");
    setSleepMinutesError("");
    setResult2("");
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Gunakan kalkulator tidur sehat untuk menghitung waktu bangun atau tidur berdasarkan siklus tidur Anda atau durasi tidur yang diperlukan. Alat ini memberikan perkiraan waktu tidur yang tepat berdasarkan siklus tidur alami Anda dan durasi tidur yang direkomendasikan untuk kesehatan Anda. Selain itu, ini memberikan informasi berharga tentang pola tidur yang sehat dan dampaknya terhadap kualitas hidup dan kesehatan secara umum, membantu Anda memahami pentingnya tidur yang sehat dan mengadopsi kebiasaan tidur yang sehat.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Kalkulator Siklus Tidur
                </div>
                <hr />
                <form onSubmit={handleSubmitCycle}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", marginBottom: "16px" }}>
                    <b><label>Saya ingin</label></b>
                    <div style={{ display: "flex", gap: "24px", marginTop: "8px" }}>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <input
                          type="radio"
                          value="wakeup"
                          checked={sleepType === "wakeup"}
                          onChange={(e) => setSleepType(e.target.value)}
                        />
                        Bangun pada pukul
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <input
                          type="radio"
                          value="goToSleep"
                          checked={sleepType === "goToSleep"}
                          onChange={(e) => setSleepType(e.target.value)}
                        />
                        Tidur pada pukul
                      </label>
                    </div>
                  </div>

                  <div className="mb-3 d-flex" style={{ alignItems: "flex-end", gap: "10px" }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>Jam</label>
                      <select
                        value={hours}
                        onChange={handleHoursChange}
                        required
                        className="form-control"
                        style={{ width: "80px" }}
                      >
                        {Array.from({ length: 12 }, (_, i) => i + 1).map((h) => (
                          <option key={h} value={h}>{h}</option>
                        ))}
                      </select>
                    </div>
                    <span style={{ marginBottom: "8px" }}>:</span>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>Menit</label>
                      <select
                        value={minutes}
                        onChange={handleMinutesChange}
                        required
                        className="form-control"
                        style={{ width: "80px" }}
                      >
                        {Array.from({ length: 60 }, (_, i) => i).map((m) => (
                          <option key={m} value={m}>{String(m).padStart(2, "0")}</option>
                        ))}
                      </select>
                    </div>
                    <span style={{ marginBottom: "8px" }}>:</span>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>AM/PM</label>
                      <select
                        value={pmAm}
                        onChange={(e) => setPmAm(e.target.value)}
                        className="form-control"
                        style={{ width: "80px", fontSize: "14px" }}
                      >
                        <option value="AM">Pagi</option>
                        <option value="PM">Malam</option>
                      </select>
                    </div>
                  </div>

                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <span>Panjang siklus tidur saya adalah</span>
                    <input
                      placeholder="30"
                      value={sleepCycle}
                      onChange={handleSleepCycleChange}
                      required
                      className="form-control d-inline-block"
                      style={{ width: "80px", margin: "0 5px" }}
                    />
                    <span>menit</span>
                    <br />

                  </div>
                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <span>Saya membutuhkan</span>
                    <input
                      placeholder="30"
                      value={takesToSleep}
                      onChange={handleTakesToSleepChange}
                      required
                      className="form-control d-inline-block"
                      style={{ width: "100px", margin: "0 5px" }}
                    />
                    <span>menit untuk tidur</span>
                  </div>
                  <hr />

                  <div className="mb-3">
                    <button type="submit" className="btn btn-success" style={{ marginRight: "25px", padding: "5px 25px", fontSize: "15px" }}>
                      Hitung
                    </button>
                    <button type="button" className="btn btn-secondary" style={{ marginRight: "25px", padding: "5px 25px", fontSize: "15px" }} onClick={onReset1}>
                      Hapus hasil
                    </button>
                  </div>
                </form>
              </div>
              <br />
              <div className="col-12 col-md-6">
                {result1 && (
                  <div dangerouslySetInnerHTML={{ __html: result1 }} />
                )}
              </div>
            </div>
            <hr />
            <br />
            <div className="row">
              <div className="col-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Kalkulator Durasi Tidur
                </div>
                <hr />
                <br />
                <form onSubmit={handleSubmitLength}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", marginBottom: "16px" }}>
                    <b><label>Saya ingin</label></b>
                    <div style={{ display: "flex", gap: "24px", marginTop: "8px" }}>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <input
                          type="radio"
                          value="wakeup"
                          checked={sleepType2 === "wakeup"}
                          onChange={(e) => setSleepType2(e.target.value)}
                        />
                        Bangun pada pukul
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <input
                          type="radio"
                          value="goToSleep"
                          checked={sleepType2 === "goToSleep"}
                          onChange={(e) => setSleepType2(e.target.value)}
                        />
                        Tidur pada pukul
                      </label>
                    </div>
                  </div>
                  <div className="mb-3 d-flex" style={{ alignItems: "flex-end", gap: "10px" }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>Jam</label>
                      <select
                        value={hours2}
                        onChange={handleHours2Change}
                        required
                        className="form-control"
                        style={{ width: "80px" }}
                      >
                        {Array.from({ length: 12 }, (_, i) => i + 1).map((h) => (
                          <option key={h} value={h}>{h}</option>
                        ))}
                      </select>
                    </div>
                    <span style={{ marginBottom: "8px" }}>:</span>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>Menit</label>
                      <select
                        value={minutes2}
                        onChange={handleMinutes2Change}
                        required
                        className="form-control"
                        style={{ width: "80px" }}
                      >
                        {Array.from({ length: 60 }, (_, i) => i).map((m) => (
                          <option key={m} value={m}>{String(m).padStart(2, "0")}</option>
                        ))}
                      </select>
                    </div>
                    <span style={{ marginBottom: "8px" }}>:</span>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>AM/PM</label>
                      <select
                        value={pmAm2}
                        onChange={(e) => setPmAm2(e.target.value)}
                        className="form-control"
                        style={{ width: "80px", fontSize: "14px" }}
                      >
                        <option value="AM">Pagi</option>
                        <option value="PM">Malam</option>
                      </select>
                    </div>
                  </div>

                  <b><label>Saya ingin tidur selama</label></b>
                  <div className="mb-3 d-flex" style={{ alignItems: "flex-end", gap: "10px" }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>Jam</label>
                      <select
                        value={sleepHours}
                        onChange={handleSleepHoursChange}
                        required
                        className="form-control"
                        style={{ width: "130px" }}
                      >
                        {Array.from({ length: 13 }, (_, i) => i).map((h) => (
                          <option key={h} value={h}>{h}</option>
                        ))}
                      </select>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>Menit</label>
                      <select
                        value={sleepMinutes}
                        onChange={handleSleepMinutesChange}
                        required
                        className="form-control"
                        style={{ width: "140px" }}
                      >
                        {Array.from({ length: 60 }, (_, i) => i).map((m) => (
                          <option key={m} value={m}>{String(m).padStart(2, "0")}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <hr />

                  <div className="mb-3">
                    <button type="submit" className="btn btn-success" style={{ marginRight: "25px", padding: "5px 25px", fontSize: "15px" }}>
                      Hitung
                    </button>
                    <button type="button" className="btn btn-secondary" style={{ marginRight: "25px", padding: "5px 25px", fontSize: "15px" }} onClick={onReset2}>
                      Hapus hasil
                    </button>
                  </div>
                </form>
              </div>
              <div className="col-12 col-md-6">
                {result2 && (
                  <div dangerouslySetInnerHTML={{ __html: result2 }} />
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Semua yang Perlu Anda Ketahui tentang Tidur: Cara Menghitung dan Pentingnya dalam Rutinitas Harian Anda
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>Siklus Tidur</h2>
                </u>
                <br />
                <p>
                  Siklus tidur dapat didefinisikan sebagai osilasi antara tidur REM (gerakan mata cepat) dan tidur non-REM, yang akan dibahas di bawah. Waktu tidur sangat tergantung pada sinyal hormonal dari jam biologis. Jam biologis menunjukkan ritme teratur yang sesuai dengan sinyal eksternal (seperti malam/siang) dan dapat berlanjut bahkan jika sinyal eksternal tiba-tiba hilang. Contohnya adalah jet lag, di mana ritme sirkadian tubuh terganggu karena perjalanan jarak jauh yang cepat, menyebabkan ketidaksesuaian pelancong dengan waktu setempat. Pelancong kemudian merasa lebih lambat atau lebih cepat dari yang biasa dilakukan tubuh, mempengaruhi tidur mereka. Idealnya, siklus tidur seseorang mengikuti jam biologis, tetapi tidur dapat dipengaruhi oleh banyak faktor seperti cahaya, waktu sosial (kapan orang lain bangun, kapan pekerjaan diperlukan, dll.), tidur siang, genetika, dan lainnya.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>Tidur REM dan non-REM</h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Selama tidur, otak menggunakan energi jauh lebih sedikit daripada saat seseorang terjaga, terutama selama tidur non-REM. Tidur REM adalah jenis tidur yang ditandai dengan beberapa aspek, termasuk gerakan mata yang memberinya nama, kelumpuhan tubuh virtual, dan terjadinya mimpi. Tidur non-REM dan tidur REM adalah dua kategori tidur yang sangat berbeda.
                  <br /> Biasanya, tubuh berosilasi antara tidur non-REM dan tidur REM selama periode rata-rata 90 menit, dan harus terjadi 4-6 kali selama tidur malam yang baik. Tidur non-REM dimulai, dan akhirnya beralih ke tidur gelombang lambat, atau tidur nyenyak. Selama periode ini, suhu tubuh dan detak jantung menurun, otak menggunakan energi jauh lebih sedikit, sambil memulihkan pasokan ATP (adenosin trifosfat), molekul yang digunakan untuk menyimpan dan mentransfer energi. Selama tidur gelombang lambat, hormon pertumbuhan juga disekresikan, yang sangat penting untuk pertumbuhan manusia.
                  <br /> Tidur REM biasanya mencakup persentase waktu tidur yang lebih kecil, dan mungkin paling dikenal sebagai saat mimpi atau mimpi buruk biasanya terjadi. Kurang tidur REM dapat menyebabkan kecemasan, iritabilitas, halusinasi, dan kesulitan berkonsentrasi. Penelitian menunjukkan bahwa ketika tubuh kekurangan tidur REM, tidur berikutnya akan mencakup peningkatan upaya tubuh untuk memasuki tidur REM, serta peningkatan jumlah waktu yang dihabiskan dalam tidur REM dibandingkan dengan periode tanpa kurang tidur. Ini disebut rebound REM, dan sesuai dengan keyakinan bahwa tidur REM diperlukan bagi tubuh. Tidur REM, efeknya, dan kebutuhannya masih belum sepenuhnya dipahami, dan meskipun dianggap sebagai aspek penting dan perlu dari tidur, dalam beberapa kasus, kurang tidur REM dapat memiliki efek positif sementara.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>Kualitas Tidur</h2>
                </u>
                <br />
                <p>
                  Kualitas tidur dapat diukur dalam hal tingkat kesulitan seseorang untuk tertidur dan tetap tidur, serta berapa kali seseorang biasanya bangun dalam satu malam. Ini juga dapat diukur secara lebih subjektif dalam hal seberapa segar perasaan seseorang saat bangun. Kualitas tidur yang buruk mengganggu siklus tidur dan transisi antara tahap tidur yang berbeda. Untuk mendapatkan kualitas tidur yang baik, kebutuhan tidur harus seimbang dengan komponen tidur harian. Idealnya, waktu tidur harus seimbang sehingga konsentrasi melatonin maksimum dan suhu tubuh minimum terjadi setelah pertengahan periode tidur dan sebelum bangun.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Berapa banyak tidur yang saya butuhkan?
                  </h2>
                </u>
                <br />
                <p>
                  Tidur tidak sepenuhnya dipahami, dan jumlah tidur yang dibutuhkan seseorang dapat sangat bervariasi berdasarkan ukuran tertentu, seperti usia, serta secara individual. Seseorang yang cukup tidur tidak boleh mengalami kantuk atau disfungsi siang hari. Secara umum, para peneliti menemukan bahwa tidur 6-7 jam per malam dikaitkan dengan sejumlah hasil kesehatan yang positif, tetapi ada juga banyak faktor lain yang dapat mempengaruhi hasil ini. Seiring bertambahnya usia, seseorang cenderung tidur lebih sedikit, dengan bayi baru lahir tidur jauh lebih lama daripada orang dewasa. Perbedaan ini berkurang seiring bertambahnya usia, dan kebutuhan tidur menjadi lebih mirip dengan kebutuhan orang dewasa mulai sekitar usia lima tahun. Berikut adalah rekomendasi CDC untuk jumlah jam tidur seseorang berdasarkan usia mereka.
                </p>
                <hr />
              </div>
            </div>
          </div>
          <br />
          <u>
            <h2>Beberapa tabel ilustratif:</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Jam Tidur yang Direkomendasikan per Hari:
                </h3>
              </div>
              <div className="info-section-body">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Jam Tidur yang Direkomendasikan per Hari (jam)</th>
                      <th>Kelompok Usia (Tahun)</th>
                     </tr>
                  </thead>
                  <tbody>
                    {data1.map((row) => (
                      <tr key={row.ageGroup}>
                        <td>{row.recommendedHours}</td>
                        <td style={{ padding: "10px" }}>{row.ageGroup}</td>
                       </tr>
                    ))}
                  </tbody>
                 </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SleapCalculator;